export const AREA_ID_LIST = [
    {id: "1", name: "札幌"},
    {id: "3", name: "旭川"},
    {id: "6", name: "室蘭"},
    {id: "8", name: "函館"},
    {id: "9", name: "帯広"},
    {id: "10", name: "釧路"},
    {id: "12", name: "北見"},
    {id: "13", name: "青森"},
    {id: "16", name: "岩手"},
    {id: "19", name: "宮城"},
    {id: "22", name: "秋田"},
    {id: "25", name: "山形"},
    {id: "28", name: "福島"},
    {id: "31", name: "茨城"},
    {id: "33", name: "栃木"},
    {id: "35", name: "群馬"},
    {id: "37", name: "埼玉"},
    {id: "40", name: "千葉"},
    {id: "42", name: "東京"},
    {id: "45", name: "神奈川"},
    {id: "50", name: "山梨"},
    {id: "51", name: "長野"},
    {id: "56", name: "新潟"},
    {id: "58", name: "富山"},
    {id: "60", name: "石川"},
    {id: "62", name: "福井"},
    {id: "64", name: "岐阜"},
    {id: "67", name: "静岡"},
    {id: "73", name: "愛知"},
    {id: "76", name: "三重"},
    {id: "79", name: "滋賀"},
    {id: "81", name: "京都"},
    {id: "84", name: "大阪"},
    {id: "85", name: "兵庫"},
    {id: "91", name: "奈良"},
    {id: "93", name: "和歌山"},
    {id: "95", name: "鳥取"},
    {id: "96", name: "島根"},
    {id: "98", name: "岡山"},
    {id: "101", name: "広島"},
    {id: "105", name: "山口"},
    {id: "109", name: "徳島"},
    {id: "110", name: "香川"},
    {id: "112", name: "愛媛"},
    {id: "116", name: "高知"},
    {id: "117", name: "福岡"},
    {id: "120", name: "北九州"},
    {id: "122", name: "佐賀"},
    {id: "123", name: "長崎"},
    {id: "126", name: "熊本"},
    {id: "127", name: "大分"},
    {id: "129", name: "宮崎"},
    {id: "131", name: "鹿児島"},
    {id: "134", name: "沖縄"}
];

export const AREA_ID_OF_TOKYO = 42;

export const MINDS_AREA_TO_GGM_GROUP_ID = {
    "1": "10",
    "3": "12",
    "6": "16",
    "8": "11",
    "9": "13",
    "10": "14",
    "12": "15",
    "13": "22",
    "16": "20",
    "19": "17",
    "22": "18",
    "25": "19",
    "28": "21",
    "31": "26",
    "33": "28",
    "35": "25",
    "37": "29",
    "40": "27",
    "42": "23",
    "45": "24",
    "50": "32",
    "51": "30",
    "56": "31",
    "58": "37",
    "60": "34",
    "62": "36",
    "64": "39",
    "67": "35",
    "73": "33",
    "76": "38",
    "79": "45",
    "81": "41",
    "84": "40",
    "85": "42",
    "91": "44",
    "93": "43",
    "95": "49",
    "96": "48",
    "98": "47",
    "101": "46",
    "105": "50",
    "109": "53",
    "110": "52",
    "112": "51",
    "116": "54",
    "117": "55",
    "120": "63",
    "122": "61",
    "123": "57",
    "126": "56",
    "127": "60",
    "129": "59",
    "131": "58",
    "134": "62"
}


// WEBPACK FOOTER //
// ./src/components/configure/configure.js